import toast from "react-hot-toast";
import {gql} from "@apollo/client";
import  {client} from "@/app/ApolloClient";

const query = gql`
  query formSubmission($organizationId: UUID!, $submissionId: UUID!) {
    formSubmission(organizationId: $organizationId, submissionId: $submissionId){     
      submission_id, 
      resource_id,
      data,
      submitted_by_account_id
    }

  }
`;

export function apiGetformSubmission(organizationId, submissionId) {
    return new Promise(async (resolve, reject) => {
      
      if (!organizationId) return reject("organizationId is required");
      if (!submissionId) return reject("submissionId is required");
      console.log("test");
      client
        .query({
          query: query,
          variables: { organizationId, submissionId },
          errorPolicy: "ignore",
          fetchPolicy: "network-only"
        })
        .then((result) => {
          console.log("test22");
          resolve(result.data.formSubmission|| {});
        })
        .catch((err) => {
          toast.error("API Error: Unable to get form submissions");
          reject(err);
        });
    });
  }
  